<template>
  <div>
    <el-dialog custom-class="customDialog" :title="$t('İştirakçı')" :close-on-press-escape="false"
      :close-on-click-modal="false" :visible.sync="showModal" :width="labelWidth === '210px' ? '80%' : '100%'" top="5vh"
      append-to-body @open="opened()">
      <el-form :disabled="readonly" ref="policy" :model="item" :label-position="labelPosition" :label-width="labelWidth"
        size="small" :rules="rules" v-loading="loading">

        <hr v-if="(!insured) || (insured && mode === 'New')"
          style="width: 100%; margin: 10px 0; height: 1px; background: #d3d3d3;">
        <el-tabs v-model="activeName" plane>
          <div class="form-container" style="width: 100%;">

            <div v-if="mode == 'New'" style="margin-bottom: 15px;">
              <el-switch @change="participantChanged" v-model="insured" :active-text="$t('Sığortalı')"
                :inactive-text="$t('Üçüncü_tərəf')" />
            </div>

            <div v-if="(!insured) || (insured && mode === 'New') || (mode === 'Edit')"
              style="display: flex; align-items: flex-start; gap: 20px; margin-bottom: 15px;">

              <div v-if="(!insured) || (insured && mode === 'New')">
                <el-form-item prop="damageType" label-width="100px">
                  <el-select @change="changeDamageType()" v-model="item.damageType" :placeholder="$t('Seçin')"
                    size="small" style="width: 200px">
                    <el-option :value="1" :label="$t('Nəqliyyat_vasitəsi')" />
                    <el-option :value="2" :label="$t('Bədən_xəsarəti')" />
                    <el-option v-if="!insured" :value="3" :label="$t('Əmlak')" />
                  </el-select>
                </el-form-item>
              </div>

              <div>
                <el-form-item label-width="100px">
                  <el-input :disabled="!insured && item.damageType !== 1" v-mask="'XXXXXXXXXXXX'"
                    v-model="searchRegNumber" style="width: 250px" :placeholder="$t('Dövlət_qeydiyyat_nişanı')">
                    <template #append>
                      <el-button class="primary" size="small" icon="el-icon-search" @click="onsearch(searchRegNumber)"
                        :disabled="mode === 'Edit' && insured && this.item.insuranceType !== null" />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
            </div>

          </div>
          <hr width="100%" size="50" style=" margin-top: 0;position: relative;height: 0.5px;background: #f5f4f3;"
            align="center">

          <div class="row" v-if="!item.noInfo">
            <div class="col-md-6 col-12 ">
              <el-form-item :label="$t('Şəxs_növü')" v-if="!insured" prop="personType">

                <el-radio-group :disabled="(insured) || (!insured && this.item.participantType === 3)"
                  v-model="item.personType">
                  <div>
                    <el-radio :label="1">{{$t('Fiziki')}}</el-radio>
                    <el-radio :label="2">{{$t('Hüquqi')}}</el-radio>
                    <el-radio :label="3">{{$t('Fərdi_sahibkar')}}</el-radio>
                  </div>

                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('DQN')" v-if="item.damageType === 1" prop="regNumber">
                <el-input v-model="item.regNumber" :readonly="insured && standalone"></el-input>
              </el-form-item>
              <el-form-item v-if="(this.item.participantType === 3)" :label="$t('Sığorta_müddəti')"
                prop="insurancePeriod">
                <el-input v-if="(insured && standalone) || (!insured && this.item.participantType === 3)"
                  v-model="item.insurancePeriod" readonly></el-input>

              </el-form-item>
              <el-form-item v-if="(insured) || (!insured && this.item.participantType === 3)" :label="$t('SŞ')"
                prop="policyNumber">
                <policies v-model="policyIndex" @onsearch="onsearch" :policynumber="item.policyNumber"
                  :policies="this.policies">
                </policies>
              </el-form-item>
              <el-form-item v-if="(this.policy.policy_type === 'Könüllü') ||  (this.item.insuranceType === 2)"
                :label="$t('Sığorta_növü')" prop="policySection">
                <el-select v-model="selectedSection" :placeholder="$t('Seçin')" size="small" style="width: 100%"
                  @change="handleSectionChange" filterable clearable value-key="ins_type">
                  <el-option v-for="section in policySections" :key="section.ins_type" :label="section.ins_type_name"
                    :value="section" />
                </el-select>
              </el-form-item>

              <el-form-item v-if="(insured) || (!insured && this.item.participantType === 3)"
                :label="$t('Sığorta_müddəti')" prop="insurancePeriod">
                <el-input v-if="(insured && standalone) || (!insured && this.item.participantType === 3)"
                  v-model="item.insurancePeriod" readonly></el-input>

              </el-form-item>
              <el-form-item :label="$t('Marka_model')" prop="customBrandModel"
                v-if="standalone && item.damageType === 1">
                <span>{{ item.customBrandModel }}</span>
                <div>
                  <brand-model :brand="item.brandId" :model="item.modelId" :brand-name="item.brandName"
                    :model-name="item.modelName" :custom-brand-model="item.customBrandModel" :disabled="readonly"
                    @change="handleBrandModelChange" />
                </div>
              </el-form-item>
              <el-form-item v-if="(insured || item.participantType === 3)"
                :label="item.personType === 1 ? $t('FİN') : $t('VÖEN')" prop="identNumber">
                <el-input id="search" readonly v-model="item.identNumber" style="width: 100%;">

                </el-input>
              </el-form-item>
              <el-form-item v-if="(!insured && item.participantType !== 3)"
                :label="item.personType === 1 ? $t('FİN') : $t('VÖEN')" prop="identNumber">
                <el-checkbox @change="onIsInsuredIdent" v-if="insured"
                  v-model="isInsuredIdent">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                <el-input id="search" v-model="item.otherIdentNumber" style="width: 100%;">
                  <span v-if="mode == 'New'" slot="append">&nbsp;</span>
                  <el-button class="primary" size="small" slot="append" icon="el-icon-search"
                    @click="item.personType === 1 ? onSearchAsan('PersonalInfo') : onSearchAsan('VoenInfo')">
                  </el-button>
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('Təqribi_zərər')"
                v-if="item.damageType !== 1 && item.damageType !== 2 && !insured" prop="damageSum">
                <el-input type="number" v-model="item.damageSum"></el-input>
              </el-form-item>

              <!-- <el-form-item v-if="!insured && item.damageType === 1" :label="$t('Sığorta_şirkəti_yoxdur')"
                prop="noInfoCompany">
                <el-checkbox :true-label="1" :false-label="0" @change="onNoInfoCompany" v-model="item.noInfoCompany">
                </el-checkbox>
              </el-form-item> -->


              <el-form-item v-if="((insured) || (!insured && this.item.participantType === 3)) ||
                (item.personType !== 1)" prop="personName"
                :label="item.personType === 2 ? $t('Şirkətin_adı') : $t('A.S.A.')">
                <el-input v-model="item.personName" :readonly="insured || item.participantType === 3"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Əlaqə_nömrəsi')"
                v-if="(insured) || (!insured && this.item.participantType === 3)" prop="phone">
                <phone :readonly="insured || item.participantType === 3" v-model="item.phone" />
              </el-form-item>
              <el-form-item :label="$t('Sürücülük_təcrübəsi')" v-if="item.damageType === 1 && !insured"
                prop="drivingYears">
                <el-radio-group v-model="item.drivingYears">
                  <el-radio :label="1">{{$t('2_ildən_az')}}</el-radio>
                  <el-radio :label="0">{{$t('2_ildən_çox')}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Sığorta_şirkəti')" v-if="!insured && item.damageType === 1"
                prop="insuranceCompId">
                <el-checkbox :true-label="1" :false-label="0" @change="onNoInfoCompany" v-model="item.noInfoCompany">
                  {{$t('Sığorta_şirkəti_yoxdur')}} </el-checkbox>
                <div>
                  <insurance-companies :disabled="item.noInfoCompany" v-model="item.insuranceCompId"
                    @input="updateField('insuranceCompId', $event)">
                  </insurance-companies>
                </div>

              </el-form-item>
              <el-form-item :label="$t('VIN')" v-if="standalone && item.damageType === 1 && insured" prop="vin">
                <el-input v-model="item.vin" :readonly="insured && standalone"></el-input>
              </el-form-item>
              <el-form-item :label="$t('VİN-in_uyğunluğu')" v-if="standalone && item.damageType === 1 && insured"
                prop="vinCheck">
                <el-radio-group v-model="item.vinCheck">
                  <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                  <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                </el-radio-group>
              </el-form-item>

              <div v-if="item.damageType === 1 && insured">

                <el-form-item :label="$t('Sürücünün_A.S.A.')" prop="partPersonName">
                  <el-checkbox @change="onIsInsured" v-model="isInsured">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>

                  <el-input v-upper v-letter :placeholder="$t('A.S.A.')" v-model="item.partPersonName" size="small">
                  </el-input>

                </el-form-item>
                <el-form-item :label="$t('Sürücünün_telefon_nömrəsi')" prop="partPersonPhone">
                  <el-checkbox @change="onIsInsuredPhone"
                    v-model="isInsuredPhone">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                  <phone v-model="item.partPersonPhone" />
                </el-form-item>

                <el-form-item :label="$t('Əlavə_nömrə')" prop="otherDriverPhone">
                  <phone ref="phone" v-model="item.otherDriverPhone" />
                </el-form-item>

              </div>


            </div>
            <div class="col-md-6 col-12">


              <div v-if="(insured && item.damageType !== 1) || (!insured)">

                <el-form-item :label="getLabelNameForDamageType(item.damageType)" prop="partPersonName">
                  <el-checkbox @change="onIsInsured" v-if="item.participantType === 3 || insured" v-model="isInsured">
                    {{$t('Sığortalı_ilə_eynidir')}}
                  </el-checkbox>

                  <el-input v-upper v-letter :placeholder="$t('A.S.A.')" v-model="item.partPersonName" size="small">
                  </el-input>
                </el-form-item>

                <el-form-item :label="getLabelPhoneForDamageType(item.damageType)" prop="partPersonPhone">
                  <el-checkbox @change="onIsInsuredPhone" v-if="this.item.participantType === 3 || insured"
                    v-model="isInsuredPhone">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                  <phone v-model="item.partPersonPhone" />
                </el-form-item>
                <el-form-item :label="$t('Əlavə_nömrə')" prop="otherDriverPhone">
                  <phone ref="phone" v-model="item.otherDriverPhone" />

                </el-form-item>
                <el-form-item v-if="item.damageType === 3" :label="$t('Əmlak_adı')" prop="otherPropertyName">
                  <el-input v-model="item.otherPropertyName"></el-input>
                </el-form-item>
              </div>

              <el-form-item :label="$t('İstifadə_məqsədi')"
                v-if="item.damageType === 1 && item.insuranceType === 2 && (item.participantType !== 2)"
                prop="purposeOfUse">


                <vue-select v-if="item.damageType === 1" :options="[
                  { label: $t('Şəxsi'), value: 1 },
                  { label: $t('İctimai_nəqliyyat'), value: 2 },
                  { label: $t('Taksi'), value: 3 },
                  { label: $t('Digər'), value: 4 },
                ]" v-model="item.purposeOfUse" :placeholder="$t('Seçin')" :label="$t('label')"
                  :reduce="option => option.value">
                </vue-select>
              </el-form-item>

              <el-form-item v-if="item.purposeOfUse === 4 && item.damageType === 1" :label="$t('Digər_məqsəd')"
                prop="otherPurposeOfUse">
                <el-input v-model="item.otherPurposeOfUse">
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('İstehsal_ili')" v-if="item.damageType === 1" prop="productionYear">
                <el-input type="number" v-model="item.productionYear" :readonly="insured && standalone">
                </el-input>
              </el-form-item>

              <el-form-item :label="$t('Təqribi_zərər')" v-if="item.damageType === 1 || insured" prop="damageSum">
                <el-input type="number" v-model="item.damageSum"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Sürücülük_hüququ')" v-if="item.damageType === 1" prop="driverLicense">
                <vue-select v-if="item.damageType === 1" :disabled="readonly || accidentStatus >= 151" :options="[
                      { label: $t('NV-nin_sahibi'), value: 1 },
                      { label: $t('Yol_vərəqəsi_əsasında'), value: 2 },
                      { label: $t('Hüququ_olmayan_şəxs'), value: 3 },
                      { label: $t('Sahibi_yanında(canlı_etibarnamə)'), value: 4 },
                      { label: $t('Etibarnamə'), value: 5 },
                      { label: $t('Sürücülük_hüququ_yoxdur'), value: 6 }
                    ]" v-model="item.driverLicense" :placeholder="$t('Seçin')" :label="$t('label')"
                  :reduce="option => option.value" @input="updateField('driverLicense', $event)">
                </vue-select>
              </el-form-item>

              <el-form-item :label="$t('Yürüş')"
                v-if="item.damageType === 1 && item.insuranceType === 2 && (item.participantType !== 2)" prop="mileage">
                <el-input type="number" v-model="item.mileage"></el-input>
              </el-form-item>

              <div v-if="item.damageType === 1">

                <el-form-item :label="$t('Rəsmi_dövlət_qürumu')" v-if="item.damageType === 1 && insured"
                  prop="officialAgencyId">
                  <official-agency :disabled="readonly" v-model="item.officialAgencyId"
                    @input="updateField('officialAgencyId', $event)"></official-agency>
                </el-form-item>
                <el-form-item :label="$t('Digər_qürum')" prop="otherAgency"
                  v-if="item.damageType === 1 && item.officialAgencyId === 88">
                  <el-input v-model="item.otherAgency"></el-input>
                </el-form-item>
                <div>
                  <el-form-item :label="$t('Təmir_mərkəzi')" v-if="item.damageType === 1 && insured"
                    prop="serviceCenterId">
                    <el-checkbox :true-label="1" :false-label="0" @change="onNotSendService"
                      v-model="item.notSendService">{{$t('TM_göndərilmədi')}}</el-checkbox>
                    <el-checkbox @change="onEvacuationStatus"
                      :disabled="!item.notSendService || item.notSendService === 0 ? false : true" :true-label="1"
                      :false-label="0" v-model="item.evacuationStatus">{{$t('Evak._olunub')}}</el-checkbox>
                    <service-centers ref="serviceCenters"
                      :readonly="((!item.notSendService || item.notSendService === 0) && !readonly ? false : true)"
                      v-model="item.serviceCenterId" @input="updateField('serviceCenterId', $event)">
                    </service-centers>

                  </el-form-item>
                </div>

                <div v-if="insured">
                  <div>
                    <el-form-item :label="$t('Subroqasiya_ehtimalı')" prop="subragation">
                      <el-radio-group v-model="item.subragation">
                        <el-radio :label="1">{{$t('Var')}}</el-radio>
                        <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('Dələduzluqda_şübhə')" prop="fraud">
                      <el-radio-group v-model="item.fraud">
                        <el-radio :label="1">{{$t('Var')}}</el-radio>
                        <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>

              </div>

            </div>
            <div class="col-md-12 col-12">
              <el-form-item :label="$t('Qeyd')" prop="descr">
                <el-input resize="none" v-model="item.descr"></el-input>
              </el-form-item>
            </div>
          </div>

        </el-tabs>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" v-if="!readonly" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import { ParticipantType } from "../../services/types";
  import {
    CreateParticipant,
    UpdateParticipant,
    GetParticipant,
  } from "../../services/accident";
  import Phone from "./Phone.vue";
  import ServiceCenters from "../components/ServiceCenters.vue";
  import OfficialAgency from "../components/OfficialAgency.vue";
  import InsuranceCompanies from '../components/InsuranceCompanies.vue';
  // import FinishReasons from "../components/FinishReasons.vue";
  import BrandModel from "../components/BrandModel.vue";
  import { DateTimeToJson, DateToString, DateTimeToString, DateTimeReverseToString, standalone, labelPosition } from "../../services/helper";
  import { salesapi, asanapi, newsalesapi, policySectionsApi } from "../../services/sales";
  import Policies from "../components/Policies.vue";
  import { CheckDuplicateParticipant } from "../../services/common";
  import { mask } from "vue-the-mask";
  import { LastAccidentStatus } from "../../services/common";


  export default {
    directives: {
      mask,
    },
    components: {
      Phone,
      // FinishReasons,
      BrandModel,
      ServiceCenters,
      Policies,
      OfficialAgency,
      InsuranceCompanies
    },
    computed: {
      rules() {
        let rules = {
          serviceCenterId: [
            {
              required: !this.item.notSendService,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          // brandId: [
          //   {
          //     required: this.item.brandId || !this.item.modelId,
          //     message: this.$t('Sütunmütləqdir'),
          //     trigger: ["blur", "change"],
          //   },
          // ],
          policyNumber: [
            {
              required: (!this.item.policyNumber && this.mode === "New"),
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          regNumber: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],

          insurancePeriod: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          personName: [
            {
              required: !this.item.personName && this.mode === "New",
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          phone: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          vin: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          vinCheck: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          partPersonName: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          partPersonPhone: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          driverLicense: [
            {
              required: this.insured || this.item.participantType === 3,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          damageSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],

          productionYear: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          officialAgencyId: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          insuranceCompId: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          subragation: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          fraud: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          orgName: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],

        };

        return rules;
      },
    },
    data() {
      return {
        searchRegNumber: "",
        activeName: "person",
        showModal: false,
        search: "",
        searchType: 1,
        asanType: null,
        mode: "",
        loading: false,
        item: {},
        insured: true,
        standalone: standalone,
        insPeriod: [],
        policies: [],
        policy: [],
        policyIndex: null,
        policyCount: 0,
        uid: this.$store.state.user.id,
        isInsured: null,
        isInsuredPhone: null,
        isInsuredIdent: null,
        labelWidth: '210px',
        labelPosition: labelPosition,
        keepRegNumber: false,
        readonly: false,
        asanData: {
          Personal: {},
          Voen: {},
          Vehicle: {},
        },
        roles: this.$store.state.user.roles,
        accidentStatus: null,
        policySections: [],
        selectedSection: null,
      };
    },
    methods: {
      new(id) {
        this.activeName = "person";
        this.item = new ParticipantType();
        this.item.regNumber = null;
        this.item.personType = 1;
        this.mode = "New";
        this.showModal = true;
        this.item.accidentId = id;
        this.search = null;
        this.insured = false;
        this.readonly = false;
      },
      edit(id, readonly) {
        this.readonly = readonly;
        this.loading = true;
        this.activeName = "person";
        this.mode = "Edit";
        this.showModal = true;
        this.search = null;
        this.policyCount = null;
        this.searchRegNumber = "";

        // item'i default değerlerle başlat
        this.item = new ParticipantType();

        GetParticipant(id).then((response) => {
          this.loading = false;
          this.isInsured = null;
          this.isInsuredPhone = null;

          if (response.data.isSuccess) {
            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
              this.item = { ...response.data.data?.[0] };
            } else if (typeof response.data.data === 'object' && response.data.data !== null) {
              this.item = { ...response.data.data };
            } else {
              this.$message({
                type: "warning",
                message: this.$t('Səhv_əməliyyat'),
              });
              this.showModal = false;
              return;
            }

            if (this.item.insType) {
              this.selectedSection = {
                ins_type: this.item.insType,
                ins_type_name: this.item.insTypeName,
                sum_insured: this.item.insuredSum
              };
              this.policySections = [this.selectedSection];
            }

            this.insured = this.item.participantType === 1;
            this.policyIndex = this.item.policyIndex;

            this.$nextTick(() => {
              if (this.$refs.policy) {
                this.$refs.policy.clearValidate();
              }
            });
          } else {
            this.showModal = false;
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        }).catch((error) => {
          this.loading = false;
          this.showModal = false;
          this.$message({
            type: "error",
            message: this.$t('Xəta_baş_verdi_7'),
          });
        });
      },
      fetchPolicySections(policyId) {
        if (policyId) {
          policySectionsApi(1, policyId).then(response => {
            this.policySections = response.data;
            this.selectedSection = null;
            this.item.insType = null;
            this.item.insTypeName = null;
            this.item.insuredSum = null;
          }).catch(error => {
            console.error("Error fetching policy sections:", error);
          });
        }
      },
      handleSectionChange(section) {
        this.selectedSection = section;
        if (section) {
          this.item.insType = section.ins_type;
          this.item.insTypeName = section.ins_type_name;
          this.item.insuredSum = section.sum_insured !== undefined ? section.sum_insured : null;
          this.item.cost = section.cost;
          this.item.sumInsuredPerson = section.sum_insured_person;
          this.item.seatCount = section.seat_count;
          this.item.medicalExpense = section.medical_expense;
          this.item.sumInsuredPersonTpl = section.sum_insured_person_tpl;
          this.item.sumInsuredAccident = section.sum_insured_accident;
          this.item.propertyDamageSum = section.property_damage_sum;
          this.item.medicalExpenseTotal = section.medical_expense_total;
          this.item.deductible = section.deductible;
          this.item.unconditionalDeductible = section.unconditional_deductible;
        } else {
          this.item.insType = null;
          this.item.insTypeName = null;
          this.item.insuredSum = null;
          this.item.cost = null;
          this.item.sumInsuredPerson = null;
          this.item.seatCount = null;
          this.item.medicalExpense = null;
          this.item.sumInsuredPersonTpl = null;
          this.item.sumInsuredAccident = null;
          this.item.propertyDamageSum = null;
          this.item.medicalExpenseTotal = null;
          this.item.deductible = null;
          this.item.unconditionalDeductible = null;
        }
      },

      lastAccidentStatus() {
        LastAccidentStatus(this.item.accidentId).then((response) => {
          if (response && response.data) {
            this.accidentStatus = response.data;
          }
          else {

          }
        })
      },

      checkDuplicateParticipant() {
        return new Promise((resolve, reject) => {
          CheckDuplicateParticipant(this.item.accidentId, this.item.regNumber, this.item.damageType).then((response) => {
            resolve(response.data);
          }, error => {
            reject(error);
          })
        })
      },
      formatPhoneNumber(phoneNumber) {
        if (!phoneNumber) return null;

        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})$/);

        if (match) {
          return '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4] + '-' + match[5];
        }

        return null;
      },
      onSearchAsan(asanType) {
        this.loading = true;
        const number = asanType == 'VehicleInfo' ? this.item.regNumber : this.item.otherIdentNumber;

        asanapi(asanType, number, this.uid).then((response) => {
          if (!response.data.response) {
            this.item.participantType = 2;
            this.$message({
              type: "error",
              message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın'),
            });
          } else {
            switch (asanType) {
              case 'PersonalInfo':
                this.asanData.Personal = response.data.response;
                this.item.personName = `${this.asanData.Personal.surname} ${this.asanData.Personal.name} ${this.asanData.Personal.patronymic}`;
                if (!this.insured) {
                  this.item.partPersonName = this.item.personName;
                }
                break;
              case 'VehicleInfo':
                this.asanData.Vehicle = response.data.response.car;
                Object.assign(this.item, {
                  customBrandModel: this.asanData.Vehicle.mark,
                  productionYear: this.asanData.Vehicle.manufactoringYear,
                  vin: this.asanData.Vehicle.bodyNumber,
                  participantType: 2,
                });
                break;
              case 'VoenInfo':
                this.asanData.Voen = response.data.response;
                this.item.personName = this.asanData.Voen.legalEntity.fullName;
                break;
            }
          }
          this.loading = false;
        }).catch((error) => {
          this.$message({
            type: "error",
            message: this.$t('Zəhmət_olmasa_yenidən_cəhd_edin'),
          });
          this.loading = false;
        });
      },

      onIsInsured() {
        if (this.isInsured)
          this.item.partPersonName = this.item.personName;
        else
          this.item.partPersonName = "";
      },
      onIsInsuredPhone() {
        if (this.isInsuredPhone) {
          this.item.partPersonPhone = this.item.phone;
        }
        else {
          this.item.partPersonPhone = "";
        }
      },
      getLabelNameForDamageType(damageType) {
        switch (damageType) {
          case 1:
            return this.$t('SürücününASA');
          case 2:
            return this.$t('XəsarətalanınASA');
          case 3:
            return this.$t('ƏmlaksahibininASA');
          default:
            return '';
        }
      },
      getLabelPhoneForDamageType(damageType) {
        switch (damageType) {
          case 1:
            return this.$t('Sürücününtelefonnömrəsi');
          case 2:
            return this.$t('Xəsarətalanınəlaqənömrəsi');
          case 3:
            return this.$t('Əmlakasahibinintelefonnömrəsi');
          default:
            return '';
        }
      },
      onIsInsuredIdent() {
        if (this.isInsuredIdent) {
          this.item.otherIdentNumber = this.item.identNumber;
        }
        else {
          this.item.otherIdentNumber = "";
        }
      },
      updatePolicyAttributes(policy) {
        const NA = "N/A";

        this.item.regNumber = policy.reg_number || NA;
        this.item.modelTypeId = policy.model_type_id || NA;
        this.item.modelTypeName = policy.model_type_name || NA;
        this.item.policyNumber = policy.policy_number || NA;
        this.item.insuredName = this.item.personName = policy.insured_name || NA;
        this.item.customBrandModel = policy.brand_name && policy.model_name ? `${policy.brand_name} ${policy.model_name}` : NA;
        this.item.identNumber = policy.ident_number || NA;
        this.item.phone = policy.phone ? this.formatPhoneNumber(policy.phone) : null;
        this.item.productionYear = policy.production_year || NA;
        this.item.vin = policy.vin || NA;
        this.item.insuranceType = policy.policy_type === 'İcbari' ? 1 : policy.policy_type === this.$t('Könüllü') ? 2 : undefined;
        this.item.policyId = policy.policy_id.toString();
        this.item.personType = policy.person_type;
        this.item.startDate = policy.start_date;
        this.item.endDate = policy.end_date;
        this.item.insurancePeriod = `${DateTimeReverseToString(this.item.startDate)} - ${DateTimeReverseToString(this.item.endDate)}`;
        this.item.insuranceCompId = 1;
      }
      ,
      onsearch(searchRegNumber) {
        this.loading = true;
        const regNumberToSearch = searchRegNumber || this.item?.regNumber;

        const salesApiPromise = salesapi(regNumberToSearch).then((response) => {
          return response.data || [];
        });
        const newsalesApiPromise = newsalesapi(regNumberToSearch).then((response) => {
          return response.data || [];
        });

        Promise.all([salesApiPromise, newsalesApiPromise])
          .then(([salesApiData, newsalesApiData]) => {
            this.policies = [...salesApiData].map(policy => ({
              ...policy,
              start_date: DateTimeToString(policy.start_date),
              end_date: DateTimeToString(policy.end_date),
            }));
            this.policyCount = this.policies.length;
            this.policyIndex = !this.policyIndex || this.policyCount === 1 ? 0 : this.policyIndex;
            this.policy = this.policies[this.policyIndex];
            if (this.policyCount > 0) {
              this.updatePolicyAttributes(this.policy);
              this.item.participantType = this.insured ? this.item.participantType : 3;
            } else {
              this.$message({
                type: "error",
                message: this.$t('Sığorta_şəhadətnaməsi_tapılmadı'),
              });
            }

            this.loading = false;
          })
          .catch((error) => {
            if (typeof this.policy !== 'undefined') {
              this.$message({
                type: "error",
                message: this.$t('Zəhmət_olmasa_yenidən_cəhd_edin'),
              });
            }
            this.loading = false;
          });
      }


      ,
      participantChanged() {
        if (this.standalone) {
          this.resetForm().then(() => {
            this.$nextTick(() => {
              if (this.$refs.policy) {
                this.$refs.policy.clearValidate();
              }
            });
            if (this.insured) {
              this.item.participantType = 1;
            }
            else {
              this.item.participantType = 2;
            }
            this.item.personType = 1;
            this.item.regNumber = "";
            this.item.damageType = 1;
            this.item.policyNumber = null;
            this.isInsured = null;
            this.policyIndex = null;
            this.isInsuredIdent = null;
            this.isInsuredPhone = null;
            this.item.otherIdentNumber = null;
            this.item.drivingYears = null;
            this.item.insuranceType = null;

          });
        }
      },
      changeDamageType() {
        if (this.insured) {
          this.item.participantType = 1;
        } else {
          this.item.participantType = 2;
        }
        this.item.partPersonName = "";
        this.item.regNumber = "";
        this.item.policyNumber = "";
        this.item.identNumber = "";
        this.item.oldRegNumber = "";
        this.item.partPersonPhone = "";
        this.item.vin = "";
        this.item.phone = "";
        this.item.productionYear = null;
        this.item.damageSum = null;
        this.item.customBrandModel = null;
        this.item.brandId = null;
        this.item.modelId = null;
        this.item.purposeOfUse = null;
        this.item.otherPurposeOfUse = null;
        this.item.driverLicense = null;
        this.item.officialAgencyId = null;
        this.item.otherAgency = null;
        this.item.serviceCenterId = null;
        this.item.notSendService = null;
        this.item.subragation = null;
        this.item.fraud = null;
        this.item.vinCheck = null;
        this.item.orgName = "";
        this.item.insuranceCompId = null;
        this.item.otherDriverPhone = "";
        this.item.insurancePeriod = "";
        this.item.personName = "";
        this.isInsured = null;
        this.isInsuredIdent = null;
        this.isInsuredPhone = null;
        this.item.otherIdentNumber = null;
        this.policyIndex = null;
        this.item.drivingYears = null;
        this.item.insuranceType = null;

        // Formdaki validasyon hatalarını temizle
        this.$nextTick(() => {
          if (this.$refs.policy) {
            this.$refs.policy.clearValidate();
          }
        });
      }
      ,
      opened() {
        this.resetForm().then(() => {
          this.$nextTick(() => {
            if (this.$refs.policy) {
              this.$refs.policy.clearValidate();
            }
          });
        });
      },
      resetForm() {
        return new Promise((resolve, reject) => {
          this.$nextTick(() => {
            const regNumberBackup = this.item.regNumber;
            const damageTypeBackup = this.item.damageType;
            const personTypeBackup = this.item.personType;
            this.$refs["policy"].resetFields();
            this.item.partPersonName = "";
            if (this.keepRegNumber) {
              this.item.regNumber = regNumberBackup;
              this.item.damageType = damageTypeBackup;
              this.item.personType = personTypeBackup;
            }
            this.keepRegNumber = false;

            this.item.oldRegNumber = ""
            this.item.partPersonPhone = "";
            this.item.vin = "";
            this.item.phone = "";
            this.item.productionYear = null;
            this.item.damageSum = null;
            this.item.customBrandModel = null;
            this.item.brandId = null;
            this.item.modelId = null;
            this.item.purposeOfUse = null;
            this.item.otherPurposeOfUse = null;
            this.item.driverLicense = null;
            this.item.officialAgencyId = null;
            this.item.otherAgency = null;
            this.item.serviceCenterId = null;
            this.item.notSendService = null;
            this.item.subragation = null;
            this.item.fraud = null;
            this.item.vinCheck = null;
            this.item.orgName = "";
            this.item.insuranceCompId = null;
            this.item.otherDriverPhone = "";
            this.item.insurancePeriod = "";
            this.item.personName = ""
            this.isInsured = null;
            this.isInsuredIdent = null;
            this.isInsuredPhone = null;
            this.item.otherIdentNumber = null;
            this.item.policyNumber = null;
            this.policyIndex = null;
            this.item.drivingYears = null;
            this.item.insuranceType = null;
            if (this.mode === "New") {
              this.policyIndex = null;
              this.searchRegNumber = "";
              this.policies = []
            }
          })
          resolve(this.$refs["policy"]);
        })
      },
      updateField(field, value) {
        this.item[field] = value;
        this.$refs['policy'].validateField(field);
      },
      handleBrandModelChange({ brandId, brandName, modelId, modelName }) {
        this.item.brandId = brandId;
        this.item.brandName = brandName;
        this.item.modelId = modelId;
        this.item.modelName = modelName;
      },
      damageTypeData() {
        if (this.item.damageType === 1) {
          this.item.brandId = this.item.brandId;
          this.item.modelId = this.item.modelId;
          this.item.otherPropertyNumber = null;
          this.item.otherProperty = null;
        } else {
          this.item.brandId = null;
          this.item.modelId = null;
        }
      },
      participantTypeData() {
        if (this.insured === 2) {
          this.item.policyId = null;
          this.item.startDate = null;
          this.item.endDate = null;
          this.item.policyNumber = null;
          this.item.policyStatus = null;
        }
      },
      clickSave() {
        // if (this.uid === this.item.createUser || this.mode === "New") {
        this.$refs["policy"].validate((valid) => {
          if (!valid) {
            this.$message({
              type: "warning",
              message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın'),
            });
            return false;
          } else {
            if (this.mode === "New" && this.item.damageType === 1 && this.insured) {

              this.checkDuplicateParticipant().then(response => {
                if (response == 0) {
                  this.$message({
                    type: "warning",
                    message: this.$t('Eyni_zərər_növünə_görə_eyni_avtomobil_daxil_edilə_'),
                  });
                } else {
                  this.saveParticipant();
                }
              }).catch(error => {
              })
            }
            else {
              this.saveParticipant();
            }

          }
        });
        // } else {
        //   this.$message({
        //     type: "warning",
        //     message: "Məlumatları dəyişdirmək səlahiyyətiniz yoxdur",
        //   });
        // }
      },
      onNotSendService() {
        this.item.serviceCenterId = null;
        this.item.evacuationStatus = null;
        this.$nextTick(() => {
          if (this.$refs.policy) {
            this.$refs.policy.clearValidate();
          }
          if (this.$refs.serviceCenters) {
            this.$refs.serviceCenters.reset();
          }
        });
      },

      onEvacuationStatus() {
        this.$nextTick(() => {
          if (this.$refs.policy) {
            this.$refs.policy.clearValidate();
          }
        });
      },
      onNoInfoCompany() {
        this.item.insuranceCompId = null;
        this.$nextTick(() => {
          if (this.$refs.policy) {
            this.$refs.policy.clearValidate();
          }
        });
      },
      saveParticipant() {
        this.loading = true;
        this.damageTypeData();
        this.participantTypeData();
        let acc = Object.assign({}, this.item);
        acc.commandUserId = this.uid;
        acc.startDate = DateTimeToJson(this.item.startDate);
        acc.endDate = DateTimeToJson(this.item.endDate);
        ;

        acc.policyIndex = this.policyIndex;
        console.log(acc.insuredSum)
        if (acc.insuredSum === undefined || acc.insuredSum === null || acc.insuredSum == '') {
          acc.insuredSum = 0.00;
        }
        if (this.mode === "New") {
          CreateParticipant(acc).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$emit("saved", { action: "new", id: response.data.id });
                this.showModal = false;
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        } else {
          UpdateParticipant(acc).then((response) => {
            this.loading = false;
            if (response.data) {
              if ((!response.data.isSuccess)) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ? response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.$emit("saved", { action: "edit", id: acc.id });
                this.showModal = false;
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        }
      },
      updateLabelWidth() {
        if (window.innerWidth <= 1024) {
          this.labelWidth = '152px';
        } else {
          this.labelWidth = '210px';
        }
      }
    },
    watch: {
      'item.accidentId': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal && newVal) {
            this.lastAccidentStatus();
          }
        },
      },
      policyIndex(newVal) {
        if (newVal !== null && this.policies[newVal]) {
          this.policy = this.policies[newVal];
          this.updatePolicyAttributes(this.policy);
          if (this.policy.policy_type === this.$t('Könüllü')) {
            this.fetchPolicySections(this.policy.policy_id);
          } else {
            this.policySections = [];
            this.selectedSection = null;
          }
        }
      },
    },
    mounted() {
    },
    created() {
      this.updateLabelWidth();
      window.addEventListener('resize', this.updateLabelWidth);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateLabelWidth);
    }
  };
</script>


<style lang="scss">
  .el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0;
  }

  .el-form-item {
    margin-bottom: 5px;
  }

  .el-form-item__label {
    font-size: var(--font-primary) !important;
    color: #3A3A3A !important;
    font-weight: bold;
  }

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 6px;
  }

  label {
    display: inline-block;
    margin-bottom: 0;
  }

  .custom-label {
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    background-color: white;
    border: 0;
  }

  .primary {
    color: #FFF !important;
    background-color: #409EFF !important;
    border-color: #409EFF !important;
  }

  .placeholder .el-input__inner::placeholder {
    color: var(--font-primary) !important;
  }

  /* google */
  .placeholder .el-input__inner::-webkit-input-placeholder {
    color: var(--font-primary) !important;
  }

  /* firefox */
  .placeholder .el-input__inner:-moz-placeholder {
    color: var(--font-primary) !important;
  }

  /*ie*/
  .placeholder .el-input__inner:-ms-input-placeholder {
    color: var(--font-primary) !important;
  }

  @media (max-width: 768px) and (max-height: 1024px) {
    .responsive-form-item {
      /* Your responsive styles here. For instance, */
      display: block;
    }
  }

  .flex-direction-column {
    display: flex;
    flex-direction: column;
  }

  .flex-direction-row {
    display: flex;
    flex-direction: row;
  }

  .custom-readonly .el-radio.is-disabled .el-radio__input.is-disabled .el-radio__inner {
    background-color: #fff;
    border-color: #d9d9d9;
  }

  .custom-readonly .el-radio.is-disabled .el-radio__label {
    color: #000;
  }

  .custom-readonly .el-checkbox.is-disabled .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #f30a0a;
    border-color: #1c0ed7;
  }

  .custom-readonly .el-checkbox.is-disabled .el-checkbox__label {
    color: #000;
  }

  .vs--searchable .vs__dropdown-toggle {
    cursor: text;
    height: 32px;
  }

  .customDialog.el-dialog {
    padding: 0 20px;
    color: #343232;
    font-size: var(--font-large);
    word-break: break-all;
  }

  .customDialog.el-dialog .el-dialog__header {
    padding: 25px 20px 10px;
  }
</style>